import { UPDATE_STORE_VALUE } from '../store/reducer'

export default (key, value) => (dispatch) => {
  dispatch(({ type: UPDATE_STORE_VALUE, key, value }))
}
